import { LeafBlock } from '../leaf-block.js'
import { jsonClass, jsonProperty } from '@sumbricht/json-class-serializer'
import { ScreenEditorInput } from '../decorators/screen-editor-input.js'
import { Expression } from '../../data/text-or-code.js'

@jsonClass('ReportBlock')
export class ReportBlock extends LeafBlock {
	@ScreenEditorInput({
		inputType: 'code',
		order: 1,
		label: 'Report',
		codeLanguage: 'ts',
		tsReturnType: () => 'ReportClass',
		editorSize: 'singleline',
		isBinding: false,
		isMandatory: () => true,
	})
	@jsonProperty(Expression)
	reportClassCode = new Expression()

	@ScreenEditorInput({
		inputType: 'code',
		order: 2,
		label: 'Default view',
		codeLanguage: 'ts',
		tsReturnType: () => 'string',
		editorSize: 'singleline',
		isBinding: false,
		isMandatory: () => true,
	})
	@jsonProperty(Expression)
	defaultViewCode = new Expression()

	constructor(init: Partial<ReportBlock> = {}) {
		super()
		this.init(init)
	}

	getEditorCategory(): string {
		return 'Others'
	}
}
